import { createSlice } from "@reduxjs/toolkit";
import {
  getSettings,
  updateSettings,
  getRestrictedBrands,
  getRestrictedAsins,
  getRestrictedMeltables,
  addRestrictedAsins,
  addRestrictedBrands,
  addRestrictedMeltables,
  deleteRestrictedAsins,
  deleteRestrictedBrands,
  deleteRestrictedMeltables,
  updateRestrictedMeltables,
  getSubscriptionFrequencies,
  updateSubscriptionFrequencyStatus,
} from "./thunk";

export const initialState = {
  setting: [],
  restrictedBrands: [],
  restrictedMeltables: [],
  restrictedAsins: [],
  subscriptionFrequencies: [],
  error: {},
};

const SettingsSlice = createSlice({
  name: "SettingsSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getSettings.fulfilled, (state, action) => {
      if (action.payload.success) state.setting = action.payload.data;
      else state.error = action.error.message || null;
    });

    builder.addCase(getSettings.rejected, (state, action) => {
      state.error = action.error.message || null;
    });

    builder.addCase(updateSettings.fulfilled, (state, action) => {
      state.settings = action.payload;
    });

    builder.addCase(updateSettings.rejected, (state, action) => {
      state.error = action.error.message || null;
    });

    builder.addCase(getRestrictedBrands.fulfilled, (state, action) => {
      state.restrictedBrands = [];
      if (action.payload.success) {
        state.restrictedBrands = action.payload.data;
      } else state.error = action.error.message || null;
    });
    builder.addCase(getRestrictedBrands.rejected, (state, action) => {
      state.error = action.error.message || null;
    });

    builder.addCase(getRestrictedMeltables.fulfilled, (state, action) => {
      state.restrictedMeltables = [];
      if (action.payload.success)
        state.restrictedMeltables = action.payload.data;
      else state.error = action.error.message || null;
    });
    builder.addCase(getRestrictedMeltables.rejected, (state, action) => {
      state.error = action.error.message || null;
    });

    builder.addCase(getRestrictedAsins.fulfilled, (state, action) => {
      state.restrictedAsins = [];    
      if (action.payload.success) state.restrictedAsins = action.payload.data;
      else state.error = action.error.message || null;
    });
    builder.addCase(getRestrictedAsins.rejected, (state, action) => {
      state.error = action.error.message.message || null;
    });

    //ADD
    builder.addCase(addRestrictedAsins.fulfilled, (state, action) => {
      state.restrictedAsins.push(action.payload.data);
    });

    builder.addCase(addRestrictedAsins.rejected, (state, action) => {
      state.error = action.error.message || null;
    });
    builder.addCase(addRestrictedBrands.fulfilled, (state, action) => {
      state.restrictedBrands.push(action.payload.data);
    });

    builder.addCase(addRestrictedBrands.rejected, (state, action) => {
      state.error = action.error.message || null;
    });

    builder.addCase(addRestrictedMeltables.fulfilled, (state, action) => {
      state.restrictedMeltables.push(action.payload.data);
    });

    builder.addCase(addRestrictedMeltables.rejected, (state, action) => {
      state.error = action.error.message.message || null;
    });

    //UPDATE
    builder.addCase(updateRestrictedMeltables.fulfilled, (state, action) => {
      if (action.payload.success) {
        const updatedIds = action.payload.data.map((item) =>
          item.mel_id.toString()
        );
        state.restrictedMeltables = state.restrictedMeltables.map((meltable) =>
          updatedIds.includes(meltable.mel_id.toString())
            ? {
                ...meltable,
                ...action.payload.data.find(
                  (item) =>
                    item.mel_id.toString() === meltable.mel_id.toString()
                ),
              }
            : meltable
        );
      } else state.error = action.error.message || null;
    });

    //DELETE
    builder.addCase(deleteRestrictedBrands.fulfilled, (state, action) => {
      console.log("deleteRestrictedBrands", action.payload);
      state.restrictedBrands = (state.restrictedBrands || []).filter(
        (brand) =>
          brand.reb_id.toString() !== action.payload.data.reb_id.toString()
      );
    });
    builder.addCase(deleteRestrictedBrands.rejected, (state, action) => {
      state.error = action.error.message || null;
    });
    builder.addCase(deleteRestrictedMeltables.fulfilled, (state, action) => {
      state.restrictedMeltables = (state.restrictedMeltables || []).filter(
        (meltable) =>
          meltable.mel_id.toString() !== action.payload.data.mel_id.toString()
      );
    });
    builder.addCase(deleteRestrictedMeltables.rejected, (state, action) => {
      state.error = action.error.message || null;
    });
    builder.addCase(deleteRestrictedAsins.fulfilled, (state, action) => {
      state.restrictedAsins = (state.restrictedAsins || []).filter(
        (asin) =>
          asin.rea_id.toString() !== action.payload.data.rea_id.toString()
      );
    });
    builder.addCase(deleteRestrictedAsins.rejected, (state, action) => {
      state.error = action.error.message || null;
    });

    //SUBSCRIPTION FREQUENCIES
    builder.addCase(getSubscriptionFrequencies.fulfilled, (state, action) => {
      state.subscriptionFrequencies = [];
      if (action.payload.success) {
        state.subscriptionFrequencies = action.payload.data;
      } else state.error = action.error.message || null;
    });
    builder.addCase(getSubscriptionFrequencies.rejected, (state, action) => {
      state.error = action.error.message || null;
    });

    builder.addCase(updateSubscriptionFrequencyStatus.fulfilled, (state, action) => {
      if (action.payload.success) {
        state.subscriptionFrequencies = state.subscriptionFrequencies.map((freq) =>
          freq.sfr_frequency === action.payload.data.sfr_frequency
            ? { ...freq, ...action.payload.data }
            : freq
        );
      } else state.error = action.error.message || null;
    });
    builder.addCase(updateSubscriptionFrequencyStatus.rejected, (state, action) => {
      state.error = action.error.message || null;
    });
  },
});

export default SettingsSlice.reducer;
